import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ApplicationSettingsService {

    constructor(private http: HttpClient) {
    }

    public loadSessionsManagerUrl(): Observable<string> {
        return this.http.get("/api/application/sessionsManagerUrl", {responseType: 'text'});
    }
}
